export const SET_RES='SET_RES';

export function setUpload(res) {
    return { type: SET_RES, res };
}

